import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingView } from './Loaders';

export const PrivateRoute = () => {
  const { firebaseUser, loading } = useAuth();

  if (loading) {
    return <LoadingView />
  }

  if (!firebaseUser) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export const AdminRoute = () => {
  const { firebaseUser, loading } = useAuth();
  // TODO: Implement admin check in Supabase
  // For now, allow all authenticated users

  if (loading) {
    return <LoadingView />
  }

  if (!firebaseUser) {
    return <Navigate to="/login" replace />;
  }

  // TODO: Check if user is admin from Supabase users table
  // const isAdmin = supabaseUser?.role === 'admin';
  // if (!isAdmin) {
  //   return <Navigate to="/trips" replace />;
  // }

  return <Outlet />;
};